var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2518_48105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 16.5V8.5C10 6.9087 10.6321 5.38258 11.7574 4.25736C12.8826 3.13214 14.4087 2.5 16 2.5C17.5913 2.5 19.1174 3.13214 20.2426 4.25736C21.3679 5.38258 22 6.9087 22 8.5V16.5C22 18.0913 21.3679 19.6174 20.2426 20.7426C19.1174 21.8679 17.5913 22.5 16 22.5C14.4087 22.5 12.8826 21.8679 11.7574 20.7426C10.6321 19.6174 10 18.0913 10 16.5ZM26 16.5C26 16.2348 25.8946 15.9804 25.7071 15.7929C25.5196 15.6054 25.2652 15.5 25 15.5C24.7348 15.5 24.4804 15.6054 24.2929 15.7929C24.1054 15.9804 24 16.2348 24 16.5C24 18.6217 23.1571 20.6566 21.6569 22.1569C20.1566 23.6571 18.1217 24.5 16 24.5C13.8783 24.5 11.8434 23.6571 10.3431 22.1569C8.84285 20.6566 8 18.6217 8 16.5C8 16.2348 7.89464 15.9804 7.70711 15.7929C7.51957 15.6054 7.26522 15.5 7 15.5C6.73478 15.5 6.48043 15.6054 6.29289 15.7929C6.10536 15.9804 6 16.2348 6 16.5C6.00305 18.9782 6.9249 21.3672 8.5873 23.2051C10.2497 25.043 12.5346 26.1991 15 26.45V29.5C15 29.7652 15.1054 30.0196 15.2929 30.2071C15.4804 30.3946 15.7348 30.5 16 30.5C16.2652 30.5 16.5196 30.3946 16.7071 30.2071C16.8946 30.0196 17 29.7652 17 29.5V26.45C19.4654 26.1991 21.7503 25.043 23.4127 23.2051C25.0751 21.3672 25.997 18.9782 26 16.5Z",
    fill: "url(#paint0_linear_2518_48105)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2518_48105",
    x1: 16,
    y1: 2.5,
    x2: 16,
    y2: 30.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E1500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF5F2B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2518_48105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/Microphone.2433ac248edab86688ae0b3c19033986.svg";
export { ForwardRef as ReactComponent };